module.exports = __webpack_public_path__ + "79cf744a3369b27d7ba3fd682422266e.pdf";